

























import {Component} from "vue-property-decorator";
import UserMixin from "../../mixins/UserMixin";
import UserIcon from "../common/UserIcon.vue";

@Component({
    components: {UserIcon}
})
export default class User extends UserMixin {

}
